import React from 'react';
import { Reveal } from '../components/Reveal';
import { BookingCta } from '../components/BookingCta';
import { img } from '../data/site';
const principles = [{
  title: 'Passie',
  text: 'Wij doen dit omdat we het mooi vinden. Elke auto die de deur uitgaat moet er staan zoals we hem zelf zouden willen hebben.'
}, {
  title: 'Kwaliteit',
  text: 'Enkel de beste merken uit de detailingwereld. pH-neutraal waar het kan, gemeten waar het moet.'
}, {
  title: 'Service',
  text: 'We bespreken altijd eerst wat het beste is voor uw voertuig en werken flexibel op afspraak.'
}];
export function Studio() {
  return <>
      <section className="mx-auto max-w-shell px-5 pt-24 sm:px-6 sm:pt-32 lg:px-10 lg:pt-44" data-id="element-1126" data-mp="bkus2jsm3vk3">
        <Reveal className="max-w-3xl" data-id="element-1127" data-mp="6li5m05nkqi1">
          <span className="flex items-center gap-3" data-id="element-1128" data-mp="25whw8wxe98d5">
            <span className="hairline h-px w-10" aria-hidden="true" data-id="element-1129" data-mp="25w0349613a9g" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-1130" data-mp="20yq5i68hjsaj">De studio</span>
          </span>
          <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.03] tracking-tightest text-chalk sm:text-5xl" data-id="element-1131" data-mp="mjjyynjxa31m">
            Een jong en dynamisch bedrijf met een enthousiast team.
          </h1>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-dim" data-id="element-1132" data-mp="dl7y7spcdovg">
            Passie, kwaliteit en service is waar wij voor staan en wat ons onderscheidt van overige autowasstraten
            en poetsbedrijven.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mt-14 overflow-hidden rounded-2xl border border-edge lg:mt-20" data-id="element-1133" data-mp="1a9nxigi97clr">
          <img src={img.studio} alt="Binnen in de werkplaats van Daily Car Care met twee auto's in behandeling" className="h-[320px] w-full object-cover sm:h-[500px]" data-id="element-1134" data-mp="wj1330jj08vh" />
        </Reveal>
      </section>

      <section className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-28" data-id="element-1135" data-mp="1p5vi3hxkqg1k">
        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-edge bg-edge md:grid-cols-3" data-id="element-1136" data-mp="1tyoosbclryga">
          {principles.map((p, i) => <Reveal key={p.title} delay={i * 0.06} className="group relative bg-carbon p-7 transition-colors duration-200 ease-smooth hover:bg-panel lg:p-9" data-id="element-1137" data-mp="1yv26pnu903xb" data-mpi={i}>
              <span className="font-display text-xs font-bold tracking-[0.2em] text-ember" data-id="element-1138" data-mp="1ox4ll97oqn8x">0{i + 1}</span>
              <h2 className="mt-4 font-display text-xl font-extrabold tracking-tight text-chalk" data-id="element-1139" data-mp="1kv9fzsiq1npc">{p.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-dim" data-id="element-1140" data-mp="1g39l4ehidkzm">{p.text}</p>
              <span className="absolute inset-x-0 bottom-0 h-px scale-x-0 bg-ember transition-transform duration-300 ease-smooth group-hover:scale-x-100" aria-hidden="true" data-id="element-1141" data-mp="1b4ojqbqisv9l" />
            </Reveal>)}
        </div>
      </section>

      <BookingCta data-id="element-1142" data-mp="x5oxtbue6uh4" />
    </>;
}